import { render, staticRenderFns } from "./AutoContainer.vue?vue&type=template&id=956a8448&scoped=true"
import script from "./AutoContainer.vue?vue&type=script&lang=js"
export * from "./AutoContainer.vue?vue&type=script&lang=js"
import style0 from "./AutoContainer.vue?vue&type=style&index=0&id=956a8448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956a8448",
  null
  
)

export default component.exports